export enum FontTypeEnum {
  Courier_New = 'Courier New , sans-serif',
  Arial = 'Arial , sans-serif',
  Arial_Black = 'Arial Black , sans-serif',
  Calibri = 'Calibri , sans-serif',
  Lucida_Sans = 'Lucida Sans , sans-serif',
  Gill_Sans = 'Gill Sans , sans-serif',
  Tahoma = 'Tahoma , sans-serif',
  Verdana = 'Verdana , sans-serif',
  Segoe_UI = 'Segoe UI , sans-serif',
  Times_New_Roman = 'Times New Roman , sans-serif',
  Helvetica = 'Helvetica , sans-serif',
  Sun = 'Sun , sans-serif'
}
